module.exports = __webpack_public_path__ + "static/media/IMG_20191128_143939.b58f645b.jpg";